import formatDisplayDateWithFormat from './formatDisplayDateWithFormat';
/**
 * Formats 'yyyy-MM-dd' date, or Date Object, to a display string: 'MMM d, y' or 'MMMM d, y'
 * @param date
 * @param language - 'en' or 'es' supported language
 * @param monthFormat - either 'MMM' - Jan or 'MMMM' - January.
 */
const formatDisplayDate = (date, language = 'en', monthFormat = 'MMM') => {
    return date
        ? formatDisplayDateWithFormat(date, `${monthFormat} d, y`, language)
        : '';
};
export default formatDisplayDate;
